import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { TimesheetBreakdownRule } from '../shared/models/timesheet-breakdown-rule';
import { ApiUrlProvider } from './api-url.provider';

@Injectable({
  providedIn: 'root'
})
export class TimesheetBreakdownRuleService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<TimesheetBreakdownRule[]>>{
    return this.http.get<IApiResult<TimesheetBreakdownRule[]>>(`${this.apiUrlProvider.url}/TimesheetRule`);
  }

  add(entity: TimesheetBreakdownRule): Observable<IApiResult<TimesheetBreakdownRule>>{
    return this.http.post<IApiResult<TimesheetBreakdownRule>>(`${this.apiUrlProvider.url}/TimesheetRule`, entity);
  }

  update(entity: TimesheetBreakdownRule): Observable<IApiResult<TimesheetBreakdownRule>>{
    return this.http.post<IApiResult<TimesheetBreakdownRule>>(`${this.apiUrlProvider.url}/TimesheetRule/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/TimesheetRule/${entityId}/delete`, null);
  }

  clone(entityId: number): Observable<IApiResult<TimesheetBreakdownRule>>{
    return this.http.post<IApiResult<TimesheetBreakdownRule>>(`${this.apiUrlProvider.url}/TimesheetRule/${entityId}/clone`, null);
  }

  getBreakdownRules(){
    return [
      "If input_hour >= 7.6 then [7.6 hours] else [input_hour]",
      "If input_hour < 7.6 then [0 hour] else [input_hour - 7.6]",
      "[7.6 hours]",
      "[Input hours]"
    ];
  }
}
